// @context TGW-2923 昔の現地払い・無料チケットに「事前決済に切り替える」を出す条件。
//   サーバーの料金チェックの対象外（EventsPlan#creator_ticket_price_policy_exempt?）と揃える（PR #2959 Copilot 指摘）。
import { prepaidSwitchedPrice, shouldShowLegacyTicketNotice } from './legacy_ticket';

describe('shouldShowLegacyTicketNotice（事前決済への切り替え案内を出すか）', () => {
  const base = { isEditable: true, isCompanyOwnedCircle: false };

  it.each([
    [0, '未設定'],
    [1, '会費制'],
    [2, '割り勘'],
    [99, '無料'],
  ])('一般サークルの price_type %i（%s）には出す', (priceType) => {
    expect(shouldShowLegacyTicketNotice({ ...base, priceType })).toBe(true);
  });

  it('事前決済（price_type 3）には出さない', () => {
    expect(shouldShowLegacyTicketNotice({ ...base, priceType: 3 })).toBe(false);
  });

  it('公式サークルは料金チェックの対象外なので、無料・現地決済でも出さない', () => {
    expect(shouldShowLegacyTicketNotice({ ...base, isCompanyOwnedCircle: true, priceType: 99 })).toBe(false);
    expect(shouldShowLegacyTicketNotice({ ...base, isCompanyOwnedCircle: true, priceType: 1 })).toBe(false);
  });

  it('編集できないチケットには出さない', () => {
    expect(shouldShowLegacyTicketNotice({ ...base, isEditable: false, priceType: 1 })).toBe(false);
  });
});

describe('prepaidSwitchedPrice（切り替え後の参加料）', () => {
  it('下限未満（無料の0円を含む）は下限に引き上げる', () => {
    expect(prepaidSwitchedPrice(0, 500)).toBe(500);
    expect(prepaidSwitchedPrice(300, 500)).toBe(500);
    expect(prepaidSwitchedPrice(null, 500)).toBe(500);
  });

  it('下限以上はそのまま使う', () => {
    expect(prepaidSwitchedPrice(500, 500)).toBe(500);
    expect(prepaidSwitchedPrice(1400, 500)).toBe(1400);
  });
});
